import { render, staticRenderFns } from "./MatchInfoTeams.vue?vue&type=template&id=72e251ae&scoped=true"
import script from "./MatchInfoTeams.vue?vue&type=script&lang=js"
export * from "./MatchInfoTeams.vue?vue&type=script&lang=js"
import style0 from "./MatchInfoTeams.vue?vue&type=style&index=0&id=72e251ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e251ae",
  null
  
)

export default component.exports